import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import NotificationSystem from "react-notification-system";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";

import { style } from "variables/Variables.jsx";

import dashboardRoutes from "routes/dashboard.jsx";
import { Url } from '../../shared/Url';
import Post from '../../shared/Post';

/* import Preloader from "../../views/Preloader/Preloader"; */

import logo from 'assets/img/logo_menu.png'
let peticion2 = false;
let abierto = false;
let intervalAviso = "";
let intervalchkSession = "";
let userType = "";

class Dashboard extends Component {
  state = {
    mainMenu: abierto,
    status: 0,
    user: "",
    u_type:""
  }
  
  constructor (props) {
    super (props);
    /* this.extenderSession(); */
    this.consultaDatos();
    /* this.timerChkSession(); */
  }
  

  timerAviso = () => {
    let aviso = () => {this.avisoSession();}
    intervalAviso = setTimeout(function(){aviso();}, 1140000);
    intervalAviso;
  }

  timerChkSession = () => {
    if (peticion2 = true) return null;

    peticion2 = true;

    let chkSession2 = () => {this.chkSession((resp) => {peticion2=false});}
    intervalchkSession = setInterval(function(){chkSession2();}, 60000);
    intervalchkSession;
  }

  componentWillUnmount = () => {
    
    let leerCookie = (nombre) => {
      let lista = document.cookie.split(";");
      let micookie;
      let igual;
      let valor;
      for (let i in lista) {
        let busca = lista[i].search(nombre);
        if (busca > -1) {micookie=lista[i]}
      }
      
      if (micookie === undefined) return null;
      
      igual = micookie.indexOf("=");
      valor = micookie.substring(igual + 1);
      return valor;
    }

    let valor = leerCookie("S_ID")
    let valor2 = leerCookie("U_ID");

    /* let valor = "";
    let valor2 = "";
    let lista = document.cookie.split(";");
    for (let i = 0; i <= lista.length; i++){
        if (lista[i] !== undefined) {
            let item = lista[i].split("=");
            if (item[0] === " S_ID"){
                valor = item[1];
            }else if (item[0] === " U_ID"){
              valor2 = item[1];
            }
        }
    } */

    let Content = {
        sId: valor,
        uId: valor2,
    }

    Post(`${Url}session`, Content, (resp) => {
      let data = JSON.parse(resp);
      if(data.status === 1) clearTimeout(intervalchkSession);
    });
  }
 
  chkSession = (respuesta) => {
    let leerCookie = (nombre) => {
      let lista = document.cookie.split(";");
      let micookie;
      let igual;
      let valor;
      for (let i in lista) {
        let busca = lista[i].search(nombre);
        if (busca > -1) {micookie=lista[i]}
      }
      
      if (micookie === undefined) return null;
      
      igual = micookie.indexOf("=");
      valor = micookie.substring(igual + 1);
      return valor;
    }

    let valor = leerCookie("S_ID")
    let valor2 = leerCookie("U_ID");
    
    /* let valor = "";
    let valor2 = "";
    let lista = document.cookie.split(";");
    for (let i = 0; i <= lista.length; i++){
        if (lista[i] !== undefined) {
            let item = lista[i].split("=");
            if (item[0] === " S_ID"){
                valor = item[1];
            }else if (item[0] === " U_ID"){
              valor2 = item[1];
            }
        }
    } */

    let Content = {
        sId: valor,
        uId: valor2,
    }

    Post(`${Url}session`, Content, (resp) => {
      respuesta("Ok")
      let data = JSON.parse(resp);
      if(data.status === 1) window.location.reload();
      /* if(data.status === 2) console.log("Sesión Ok"); */
    });
  }

  avisoSession = () => {
    let contenido = <div>
                      Su sesión esta apunto de expirar, haga click <a style={{fontWeight:"bold", color:"#FFF"}} onClick={this.extenderSession}>AQUI</a> para extenderla
                    </div>
    toast.info(contenido,{})
  }

  extenderSession = () => {
    clearTimeout(intervalAviso)

    let leerCookie = (nombre) => {
      let lista = document.cookie.split(";");
      let micookie;
      let igual;
      let valor;
      for (let i in lista) {
        let busca = lista[i].search(nombre);
        if (busca > -1) {micookie=lista[i]}
      }
      
      if (micookie === undefined) return null;
      
      igual = micookie.indexOf("=");
      valor = micookie.substring(igual + 1);
      return valor;
    }

    let valor = leerCookie("U_ID");

    let Content = {uId: valor,}

    Post(`${Url}updToken`, Content, (resp) => {
      let data = JSON.parse(resp);
      /* document.cookie =`S_ID=${data.s_id}; max-age=1200; path=/`;
      document.cookie =`U_ID=${data.u_id}; max-age=1200; path=/`; */
      document.cookie =`S_ID=${data.s_id}; path=/`;
      document.cookie =`U_ID=${data.u_id}; path=/`;
      /* this.timerAviso(); */
    });
  }

  consultaDatos = () => {
    
    let leerCookie = (nombre) => {
      let lista = document.cookie.split(";");
      let micookie;
      let igual;
      let valor;
      for (let i in lista) {
        let busca = lista[i].search(nombre);
        if (busca > -1) {micookie=lista[i]}
      }
      
      if (micookie === undefined) return null;
      
      igual = micookie.indexOf("=");
      valor = micookie.substring(igual + 1);
      return valor;
    }

    let valor = leerCookie("S_ID")
    let valor2 = leerCookie("U_ID");

    /* let valor = "";
    let valor2 = "";
    let lista = document.cookie.split(";");
    for (let i = 0; i <= lista.length; i++){
        if (lista[i] !== undefined) {
            let item = lista[i].split("=");
            if (item[0] === " S_ID"){
                valor = item[1];
            }else if (item[0] === " U_ID"){
              valor2 = item[1];
            }
        }
    } */

    let Content = {
        sId: valor,
        uId: valor2,
    }

    Post(`${Url}session`, Content, (resp) => {
      let data = JSON.parse(resp);
      userType= data.user_003

      if((data.status) === 1) this.setState ({status: data.status});
      if((data.status) === 2){
        this.setState ({
          status: data.status,
          user: data.user_002,
          u_type: data.user_003,
        });
      } 
    });
  }

  menuPegajoso = () => {
    if (this.state.mainMenu === false) return null;
    
    return(
      <div className="col-12 fixed-menues" style = {{position:"fixed", zIndex: 3}}><Header {...this.props} userName={this.state.user} tUser = {this.state.u_type}/></div>
    )
  }

  redirect = (key) => {
    return <Redirect to="/noticias" key={key} />
  }


  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }

  /* loadPerfil = () => {
    return (<Preloader/>)
  } */

  cargaRutas = (usuario, type, path, component, key) => {
    return (
      <Route path={path} component={component} key={key} />
    );
  }

  render() {
    switch (this.state.status) {
      case 0:
        return null;
        /* return(<Preloader/>) */
      case 1:
        return(<Redirect to="/home" />)
      case 2:
        return (
          <div className="wrapper" style={{backgroundColor: "rgba(255,255,255, 0)"}}>
          {this.menuPegajoso()}
            <NotificationSystem ref="notificationSystem" style={style} />
            <Sidebar {...this.props} userName={this.state.user} type={this.state.u_type} extend = {this.extenderSession}/>
            <div id="main-panel" className="main-panel" ref="mainPanel">
              {/* <div className="logo-fondo">
                <img src={logo} width={200} className="logo-rotate" height="auto"/>
              </div> */}
              <React.Fragment>
                <div className="wrapper2">
                  <div className="wave one"></div>
                  <div className="wave dos"></div>
                  <div className="wave tres"></div>
                  <div className="wave cuatro"></div>
                </div>
              </React.Fragment>
              <Header {...this.props} userName={this.state.user} tUser = {this.state.u_type}/>
              <Switch>
                {dashboardRoutes.map((prop, key) => {
                  if (prop.redirect) this.redirect(key)
                  
                  if (parseInt(prop.type) === 1) {
                    return (
                      <Route path={prop.path} component={prop.component} key={key} />
                    );
                  }

                  else if (parseInt(prop.type) === 2 && userType === "DIR") {
                    return (
                      <Route path={prop.path} component={prop.component} key={key} />
                    );
                  }

                  else if (parseInt(prop.type) === 3 && userType === "PROF") {
                    return (
                      <Route path={prop.path} component={prop.component} key={key} />
                    );
                  }

                  else if (parseInt(prop.type) === 4 && userType === "EST") {
                    return (
                      <Route path={prop.path} component={prop.component} key={key} />
                    );
                  }
                  else if (parseInt(prop.type) === 5 && userType === "ADMIN") {
                    return (
                      <Route path={prop.path} component={prop.component} key={key} />
                    );
                  }
                  else if (parseInt(prop.type) === 6 && userType === "WEBMASTER") {
                    return (
                      <Route path={prop.path} component={prop.component} key={key} />
                    );
                  }
                  else if (parseInt(prop.type) === 7 && userType === "CONSULTA") {
                    return (
                      <Route path={prop.path} component={prop.component} key={key} />
                    );
                  }
                })}
                <Redirect to="/home"/>
              </Switch>
              <Footer />
              <NotificationContainer/>
              <ToastContainer
                pauseOnVisibilityChange={false}
                position="bottom-right"
                autoClose={10000}/>
            </div>
          </div>
        );
      default:
        return(<Redirect to="/home" />)
    }
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx